import React, { useEffect } from "react";
import './Show_your_support.css'
import Common_Title_1 from '../../common/common_components/common_title_1/Common_Title_1'
import Support_card from '../../common/common_components/support-card/Support_card'
import { AllDonation } from '../../../features/admin/donation/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from "../../../utils/IDS";
const Show_your_support = () => {
    const dispatch = useDispatch();

    const all_donation = useSelector((state) => state.donation.all_donation);

    useEffect(() => {
        dispatch(AllDonation());
    }, [dispatch]);


    // const support = [
    //     {
    //         image: '/assets/images/explore/support/suport.png',
    //         name: 'Annadanam',
    //         content: 'The Purest Offering of Kindness'
    //     },
    //     {
    //         image: '/assets/images/explore/support/suport.png',
    //         name: 'Annadanam',
    //         content: 'The Purest Offering of Kindness'
    //     },
    //     {
    //         image: '/assets/images/explore/support/suport.png',
    //         name: 'Annadanam',
    //         content: 'The Purest Offering of Kindness'
    //     },


    // ];

    return (
        <>
            <section className='Show_your_support'>
                <div className='container-lg'>
                    <Common_Title_1 subText={'Show Your Support'} linktext={'See All'} link={'/donate'} />


                    <div className='row justify-content-center'>
                        {all_donation?.map((data, index) => (
                            <div className='col-md-4 col-sm-6 col-12  mb-3'>
                                <Support_card
                                    image={data.image}
                                    name={data.name}
                                    subname={data.subname}
                                    id={data.id}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Show_your_support